export {default} from './DealsSection.container';
